module.exports = "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzNiAzNiIgdmlld0JveD0iMCAwIDM2IDM2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Im0zNiAxNS42aC0yNy40bDEyLTExLjktMy4yLTMuNy0xNy40IDE3LjMgMTYuMSAxOC43IDMuNC0zLjQtMTAuMy0xMmgyNi44eiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back-btn.svg
// module id = 159
// module chunks = 35783957827783 112966903596346 114276838955818